module.exports = __webpack_public_path__ + "img/plus-inactive.4230c6d1.svg";